import React from "react";
import AppBar from "@material-ui/core/AppBar";
import { styled } from "@material-ui/styles";
import { IStyledArguments } from "../../../types/styled-arguments";

const HeaderBar = styled((props) => (
  <AppBar position="fixed" elevation={0} {...props} />
))(({ theme }: IStyledArguments) => ({
  background: "rgba(255, 255, 255, 0.92)",
  backdropFilter: "blur(16px)",
  WebkitBackdropFilter: "blur(16px)",
  border: `1px solid ${theme.palette.extra.borderColor}`,
  boxShadow: "0 1px 3px rgba(16, 21, 26, 0.06)",
  zIndex: theme.zIndex.drawer + 1,
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  padding: theme.spacing(0, 2),
  margin: "8px",
  width: "90%",
  marginLeft: "5%",
  marginRight: "5%",
  marginTop: "12px",
  borderRadius: 16,
}));

export default HeaderBar;
